// This error message occurs when the client has an unstable network connection.
export const isClientNetworkError = (errorMessage: string) => errorMessage === 'Failed to fetch';
